import $ from 'jquery';
import Parsley from 'parsleyjs';
import defaultValidationUI from './util';
import { unescapeHTML } from '../util/text';
import defaultSuccessMessage from '../views/autovalidate-default-success-msg.tpl.html';
import defaultErrorMessage from '../views/autovalidate-default-error-msg.tpl.html';
/**
 * Checks if value is a valid class (.) or id (#) selector.
 */

var isSelector = function isSelector(value) {
  var $el = $(value);
  return $el.length && ($el.attr('id') === value.slice(1) || $el.hasClass(value.slice(1)));
};

Parsley.addValidator('requiredIf', {
  validateString: function validateString(value, requirement) {
    if ($(requirement).is(':checked')) {
      return !!value;
    }

    return true;
  },
  messages: {
    en: 'This value is required.'
  }
}).addValidator('companyEmail', {
  requirementType: 'regexp',
  validateString: function validateString(value) {
    /**
     * Field will be valid if email is from:
     * - cigna.com
     * - express-scripts.com
     * - eviCore.com
     * - careallies.com
     * - healthspring.com
     */
    return /@(?:cigna|express-scripts|eviCore|careallies|healthspring)+(?:\.[a-zA-Z0-9-]+)*$/.test(value);
  },
  messages: {
    en: 'Thank you for your interest. We currently don\'t have volunteer opportunities available for the general public.'
  }
}).addValidator('telephone', {
  validateNumber: function validateNumber(value, requirement) {
    if ($(requirement).is(':checked')) {
      return !!value;
    }

    return true;
  }
});
export default (function () {
  var setupValidationUI = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultValidationUI;
  $(document.body).on('submit', '[data-autovalidate]', function (evt) {
    var $form = $(evt.currentTarget);
    setupValidationUI($form);
    $form.parsley().validate();

    if ($form.parsley().isValid()) {
      $form.find('[type=submit]').prop('disabled', true);
      var successAction = $form.data('autovalidateAction');

      if (['replace', 'redirect'].indexOf(successAction) >= 0) {
        var promise = $.ajax({
          url: $form.attr('action'),
          method: $form.attr('method') || 'POST',
          data: $form.serialize()
        }); // eslint-disable-next-line no-unused-vars

        promise.then(function (data) {
          var successMessageOrURL = unescapeHTML($form.data('autovalidateSuccess'));

          if (successAction === 'replace') {
            if (isSelector(successMessageOrURL)) {
              successMessageOrURL = $(successMessageOrURL).html();
            }

            successMessageOrURL = successMessageOrURL || defaultSuccessMessage;
            $form.html(successMessageOrURL);
          } else {
            // redirect
            location.assign(successMessageOrURL);
          }
        }); // eslint-disable-next-line no-unused-vars

        promise.catch(function (error) {
          var errorMessage = unescapeHTML($form.data('autovalidateError'));

          if (isSelector(errorMessage)) {
            errorMessage = $(errorMessage).html();
          }

          errorMessage = errorMessage || defaultErrorMessage;
          $form.html(errorMessage);
        });
        return false;
      } // successAction is undefined, normal non-ajax form submission


      return true;
    }

    return false;
  });
});